import { Link } from "react-router-dom";
import { Logo } from "@/components/Logo";
import { AppBadges } from "@/components/AppBadges";
import { SOCIALS as socials } from "@/data/socials";

const cols = [
  { title: "Learn", links: [["Courses", "/courses"], ["Webinars", "/events"], ["Books", "/books"], ["Knowledge Center", "/knowledge"], ["Glossary", "/glossary"]] },
  { title: "Insights", links: [["Market Insights & Analysis", "/research"], ["Calculators", "/calculators"], ["Scanners", "/scanners"], ["Strategy Library", "/strategy"]] },
  { title: "Company", links: [["About", "/about"], ["Careers", "/about"], ["Contact", "/contact"], ["Disclaimer", "/disclaimer"], ["Privacy Policy", "/privacy"], ["Terms & Conditions", "/terms"], ["Refund Policy", "/refund"], ["Delete Account", "/account-deletion"]] },
];

const SOCIAL_COLORS = null;
void SOCIAL_COLORS;

export function Footer() {
  return (
    <footer className="bg-navy-deep text-slate-300 grain" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-10">
          <div className="lg:col-span-2">
            <Logo light className="h-14 sm:h-16" />
            <p className="mt-5 font-display text-lg text-white">Systematic Financial-Market Education</p>
            <p className="mt-2 text-sm text-gold font-medium tracking-wide">Learn. Analyse. Understand.</p>
            <p className="mt-4 text-sm text-slate-400">Courses • Books • Webinars • Market Insights • Analytical Tools</p>

            <div className="flex gap-3 mt-6">
              {socials.map((s) => (
                s.href ? (
                  <a
                    key={s.label}
                    href={s.href}
                    target="_blank"
                    rel="noopener noreferrer"
                    data-testid={`social-${s.label.toLowerCase()}`}
                    aria-label={s.label}
                    className="h-9 w-9 inline-flex items-center justify-center rounded-md border border-white/10 text-slate-400 hover:text-gold hover:border-gold/40 transition-colors"
                  >
                    <s.icon className="h-4 w-4" />
                  </a>
                ) : (
                  <button
                    key={s.label}
                    data-testid={`social-${s.label.toLowerCase()}`}
                    aria-label={s.label}
                    className="h-9 w-9 inline-flex items-center justify-center rounded-md border border-white/10 text-slate-400 hover:text-gold hover:border-gold/40 transition-colors"
                  >
                    <s.icon className="h-4 w-4" />
                  </button>
                )
              ))}
            </div>

            <AppBadges />
          </div>

          {cols.map((col) => (
            <div key={col.title}>
              <h4 className="font-display text-white text-base font-semibold mb-4">{col.title}</h4>
              <ul className="space-y-2.5">
                {col.links.map(([label, to]) => (
                  <li key={label + to}>
                    <Link to={to} className="text-sm text-slate-400 hover:text-white transition-colors">
                      {label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-14 pt-8 border-t border-white/10">
          <p className="text-xs text-slate-400 text-center" data-testid="footer-copyright">
            © 2026 KRV Prime. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
}
